import isEmpty from 'lodash/isEmpty';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import {prizeImagesPageName, getInitialDrawDate} from './utils';
import {createResourceSelector} from 'resources/selectors';
import * as ResourceActions from 'resources/actions';
import {publishPrize} from 'api/prize-service';
import * as ResourceApi from 'api/resources';
import * as PrizeActions from './actions';
import {toggleSort} from 'utils/DBUtils';

const getPrizeEpic = action$ => action$.ofType(PrizeActions.Types.REQUEST_PRIZE)
  .mergeMap(action => {
    const prizeFetch$ = ResourceApi.getById(ResourceApi.Types.Prize, action.prizeId);

    return prizeFetch$
      .mergeMap(({response: {object: prizeObject}}) => Observable.of(
        ResourceActions.receivedResourceAction(ResourceApi.Types.Prize, prizeObject),
        PrizeActions.receivedPrizeAction(prizeObject),
        PrizeActions.getPrizeImagesPageAction(10, 1, prizeObject.id)
      ))
      .catch(error => Observable.of({type: 'ERROR', error}));
  });

const prizeImagesSortOptions = sortOptionsFactory('_created');
prizeImagesSortOptions.sorts = toggleSort(prizeImagesSortOptions.sorts, '_created');

const makePrizeImagesFilterOptions = prizeId => filterOptionsFactory({
  filters: [
    {field: 'imageType', value: 'original'},
    {field: 'usedBy.id', value: prizeId}
  ]
});

const getPrizeImagesPageEpic = action$ => action$.ofType(PrizeActions.Types.GET_PRIZE_IMAGES_PAGE)
  .map(action => ResourceActions.getResourcePageAction(
    ResourceApi.Types.Image,
    action.count,
    action.page,
    prizeImagesSortOptions,
    makePrizeImagesFilterOptions(action.prizeId),
    prizeImagesPageName
  ));

// when the user sets Weekly Winners to Yes/true and there aren't yet any weekly draw
// dates specified, initialize that field with one draw date with a sensible value.
const initializeDrawInfoEpic = (action$, store) => action$.ofType(ResourceActions.Types.SENT_SAVE_RESOURCE_FIELD)
  .filter(action => (
    action.resourceType === ResourceApi.Types.Prize
      && action.field === 'weeklyWinners'
      && action.value === true
  ))
  .mergeMap(action => {
    const state = store.getState();
    const getPrize = createResourceSelector(state.editPrize.currentPrizeId);
    const prize = getPrize(state.resources);

    if (isEmpty(prize.drawInfo)) {
      const field = 'drawInfo.#';
      const value = JSON.stringify({drawDate: getInitialDrawDate(prize)});

      return Observable.of(ResourceActions.saveResourceFieldAction(
        prize.resourceId,
        prize.resourceId,
        [],
        [field],
        field,
        value,
        [prize.resourceId]
      ));
    } else {
      return Observable.empty();
    }
  });

const publishPrizeEpic = action$ => action$.ofType(PrizeActions.Types.PUBLISH_PRIZE_SUBMIT)
  .mergeMap(({prizeId}) => (
    publishPrize(prizeId)
      .mapTo(PrizeActions.publishPrizeSuccessAction())
      .catch(error => Observable.of(
        error.xhr
          ? PrizeActions.publishPrizeErrorAction(error.response)
          : {type: 'ERROR', error}
      ))
  ));

export default [
  getPrizeEpic,
  getPrizeImagesPageEpic,
  initializeDrawInfoEpic,
  publishPrizeEpic
];



// WEBPACK FOOTER //
// ./public/pages/EditPrize/epics.js